import { Icon, IconProps } from "..";

export const Boots = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 4H12V5H13V6H14V9H13V13H14V14H15V15H17V16H15V17H13V18H15V17H17V18H18V17H19V20H18V21H12V20H10V19H8V18H6V17H5V13H6V9H5V6H6V5H7V4ZM12 8V7H9V8H12Z"
          fill="currentColor"
        />
        <path d="M18 17H17V16H18V17Z" fill="currentColor" />
      </>
    </Icon>
  );
};
